import { render, staticRenderFns } from "./menufacturasele.vue?vue&type=template&id=5b7fcdac"
import script from "./menufacturasele.vue?vue&type=script&lang=js"
export * from "./menufacturasele.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports